import React from 'react';
import { BsStars } from 'react-icons/bs';
import './ChatToggleIcon.css';

function ChatToggleIcon({ onClick, isOpen, ariaLabel }) {
  return (
    <button
      type="button"
      className={'chat-toggle-icon' + (isOpen ? ' chat-toggle-icon--active' : '')}
      onClick={onClick}
      aria-label={ariaLabel || (isOpen ? 'Close AI Agent chat' : 'Open AI Agent chat')}
      title={isOpen ? 'Close chat' : 'Open AI chat (split view)'}
    >
      <span className="chat-toggle-icon-svg" aria-hidden="true">
        <BsStars size={20} />
      </span>
      {/* <span className="chat-toggle-icon-label">AI</span> */}
    </button>
  );
}

export default ChatToggleIcon;
